import reducer from "./reducers";

import * as documentacionOps from "./operations";
import * as documentacionTypes from "./types";

export { documentacionOps, documentacionTypes };

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/documentacion/index.js